export default __webpack_public_path__ + "static/media/smile2.d0599be6.svg";